import ga from './analytics';
import {formatPhone} from './util';
import PropTypes from 'prop-types';
import React from 'react';

const Phone = ({classes, prefix, number}) => {
  return number ? (
    <span className={classes}>
      {prefix ? <span className="prefix">{prefix}: </span> : null}
      <a href={"tel:+1" + number} onClick={() => ga.event('Agent-Interaction', 'Phone', number)}>{formatPhone(number)}</a>
    </span>
  ) : null;
};

Phone.propTypes = {
  classes: PropTypes.string,
  number: PropTypes.string,
  prefix: PropTypes.string
};

export default Phone;



// WEBPACK FOOTER //
// ./src/components/shared/phone.js